import flatmap from "lodash/flatMap";
import { createSelector } from "reselect";
import cutsitesSelector from "./cutsitesSelector";
import filteredRestrictionEnzymesSelector from "./filteredRestrictionEnzymesSelector";
import specialCutsiteFilterOptions from "../constants/specialCutsiteFilterOptions";
import { flatMap } from "lodash-es";
import isEnzymeFilterAndSelector from "./isEnzymeFilterAndSelector";
export default createSelector(
  cutsitesSelector,
  filteredRestrictionEnzymesSelector,
  isEnzymeFilterAndSelector,
  (state, addEnzs, enzymeGroupsOverride) => enzymeGroupsOverride,
  function({ cutsitesByName }, filteredRestrictionEnzymes, isEnzymeFilterAnd, enzymeGroupsOverride) {
    const returnVal = {
      cutsitesByName: {}
    };
    const hiddenEnzymesByName = {};
    let filteredEnzymes = [];
    let enzymesFromGroups = [];
    let hasUserGroup;
    let groupCount = 0;
    filteredRestrictionEnzymes.forEach((e) => {
      if (e.value.includes("__userCreatedGroup")) {
        hasUserGroup = true;
        const existingGroups = {
          ...window.getExistingEnzymeGroups(),
          ...enzymeGroupsOverride
        };
        const enzymes = existingGroups[e.value.replace("__userCreatedGroup", "")] || [];
        const zs = flatMap(enzymes, (e2) => e2 ? { value: e2 } : []);
        filteredEnzymes = filteredEnzymes.concat(zs);
        enzymesFromGroups = enzymesFromGroups.concat(zs);
        groupCount += 1;
      } else if (e.isHidden) {
        hiddenEnzymesByName[e.value] = e;
      } else {
        if (!e) return;
        groupCount += 1;
        filteredEnzymes.push(e);
      }
    });
    const cutSiteList = [];
    if (!filteredEnzymes || filteredEnzymes.length === 0 && !hasUserGroup) {
      returnVal.cutsitesByName = cutsitesByName;
    } else {
      filteredEnzymes.forEach(function({ value, ...rest }) {
        if (!value) {
          console.error(`Missing value for filtered enzyme`, rest);
          return;
        }
        const lowerValue = value.toLowerCase();
        const cutsThisManyTimes = specialCutsiteFilterOptions[value] && specialCutsiteFilterOptions[value].cutsThisManyTimes;
        if (value === "type2s") {
          Object.keys(cutsitesByName).forEach(function(key) {
            if (hiddenEnzymesByName[key]) return;
            if (cutsitesByName[key].length && cutsitesByName[key][0]?.restrictionEnzyme?.isType2S) {
              cutSiteList.push(key);
              returnVal.cutsitesByName[key] = cutsitesByName[key];
            }
          });
        } else if (value === "important") {
          Object.keys(cutsitesByName).forEach(function(key) {
            if (hiddenEnzymesByName[key]) return;
            const importantCuts = cutsitesByName[key].filter((c) => c.isImportant);
            if (importantCuts.length) {
              cutSiteList.push(key);
              if (returnVal.cutsitesByName[key]) {
              } else {
                returnVal.cutsitesByName[key] = importantCuts;
              }
            }
          });
        } else if (cutsThisManyTimes > 0) {
          Object.keys(cutsitesByName).forEach(function(key) {
            if (hiddenEnzymesByName[key]) return;
            if (cutsitesByName[key].length === cutsThisManyTimes) {
              cutSiteList.push(key);
              returnVal.cutsitesByName[key] = cutsitesByName[key];
            }
          });
        } else {
          if (hiddenEnzymesByName[lowerValue]) return;
          if (!cutsitesByName[lowerValue]) return;
          cutSiteList.push(lowerValue);
          returnVal.cutsitesByName[lowerValue] = cutsitesByName[lowerValue];
        }
      });
    }
    const enzymeCounts = {};
    cutSiteList.forEach(
      (enzyme) => enzymeCounts[enzyme] = enzymeCounts[enzyme] ? enzymeCounts[enzyme] + 1 : 1
    );
    const intersectionCutSites = [];
    Object.keys(enzymeCounts).forEach((key) => {
      if (enzymeCounts[key] === groupCount) intersectionCutSites.push(key);
    });
    returnVal.cutsiteIntersectionCount = intersectionCutSites.length;
    const cutsbyname_AND = {};
    intersectionCutSites.forEach((value) => {
      cutsbyname_AND[value] = cutsitesByName[value];
    });
    returnVal.cutsiteTotalCount = Object.keys(returnVal.cutsitesByName).length;
    if (isEnzymeFilterAnd && returnVal.cutsiteIntersectionCount > 0) {
      returnVal.cutsitesByName = cutsbyname_AND;
    }
    returnVal.cutsitesArray = flatmap(
      returnVal.cutsitesByName,
      (cutsitesByNameArray) => cutsitesByNameArray
    );
    returnVal.cutsitesById = returnVal.cutsitesArray.reduce(function(obj, item) {
      if (item && item.id) {
        obj[item.id] = item;
      }
      return obj;
    }, {});
    return returnVal;
  }
);
